import { ajaxT } from 'util'
import axios from 'axios'

/**
 * 首页显示附近的站点
 */

export function getNearStation(params) {
  return ajaxT.post('manage/getNearStation', params)
}

/**
 * 首页根据站点名称获取途经班车信息
 */
export function getBcByStationName(params) {
  return ajaxT.post('manage/getBcByStationName', params)
}

/**
 * 添加至收藏夹
 */
export function addFavorite(params) {
  return ajaxT.post('tool/addFavorite', params)
}

/**
 * 取消收藏
 */
export function cancelFavorite(params) {
  return ajaxT.post('tool/cancelFavorite', params)
}

/**
 * 获取历史记录
 */
export function getHistory(params) {
  return ajaxT.post('tool/getHistory', params)
}

/**
 * 所有站点列表
 */
export function getStationList(params) {
  return ajaxT.post('tool/stationList', params)
}
